import React from 'react';
import DentalServicePage from './DentalServicePage';

const BracesAndAligners = () => {
    // Defined content for Braces & Aligners
    const serviceName = 'Braces & Aligners';
    const serviceTagline = 'Transform your smile with modern orthodontic solutions, from traditional braces to invisible aligners';

    const whatIsContent = [
        'Orthodontic treatment with braces and aligners is designed to gradually move misaligned teeth into their optimal positions, creating a properly aligned bite and a more attractive smile. At Wisdom Dental Clinic, we offer both traditional braces and invisible aligner options to suit different preferences and treatment needs.',
        'Traditional braces use brackets and wires to guide teeth into position, while clear aligners like Invisalign use a series of custom-made, removable transparent trays. Both methods are effective for treating various orthodontic issues, from simple to complex cases, with the choice depending on your specific needs, lifestyle preferences, and aesthetic concerns.',
    ];

    const whenRequiredContent = {
        paragraphs: ['Orthodontic treatment can address both cosmetic concerns and functional issues with your bite and tooth alignment.'],
        listIntro: 'You might benefit from braces or aligners if you have:',
        list: [
            'Crowded or overlapping teeth',
            'Gaps or spaces between teeth',
            'Overbite (upper teeth extend too far over lower teeth)',
            'Underbite (lower teeth extend past upper teeth)',
            'Crossbite (some upper teeth sit inside lower teeth)',
            "Open bite (teeth don't meet when mouth is closed)",
            'Misaligned jaw position',
            'Difficulty chewing or speaking clearly due to alignment issues',
        ],
        closing:
            'During your consultation at Wisdom Dental Clinic, our orthodontic specialists will evaluate your specific case and recommend the most suitable treatment option based on your needs and goals.',
    };

    const howDoneContent = {
        paragraphs: [
            'At Wisdom Dental Clinic, our approach to orthodontic treatment combines the latest technology with personalized care for optimal results.',
        ],
        listIntro: 'Our orthodontic services feature:',
        list: [
            '3D digital scanning for precise treatment planning (no messy impressions)',
            'Virtual treatment simulation to preview your results before starting',
            'Advanced bracket systems that are smaller and more comfortable',
            'Self-ligating braces that require fewer adjustments',
            'Invisalign® clear aligners for nearly invisible treatment',
            'Accelerated treatment options to reduce overall treatment time',
            'Customized retention plans to maintain your results',
        ],
        closing:
            'Our orthodontists have extensive training and experience in both traditional braces and clear aligner therapy, ensuring you receive the highest quality care tailored to your unique needs.',
    };

    const benefitsContent = [
        {
            title: 'Enhanced Smile Aesthetics',
            description: 'Achieve a beautifully aligned smile that boosts confidence',
        },
        {
            title: 'Improved Oral Health',
            description: 'Properly aligned teeth are easier to clean, reducing risk of decay and gum disease',
        },
        {
            title: 'Better Bite Function',
            description: 'Correct bite issues that can cause difficulties with chewing and speaking',
        },
        {
            title: 'Reduced Wear and Tear',
            description: 'Prevent abnormal wear on tooth surfaces from misalignment',
        },
        {
            title: 'Treatment Options',
            description: 'Choose from traditional braces, clear braces, or invisible aligners',
        },
        {
            title: 'Long-lasting Results',
            description: 'Enjoy the benefits of properly aligned teeth for a lifetime with proper retention',
        },
    ];

    const procedureSteps = [
        {
            title: 'Initial Consultation',
            description: 'Comprehensive examination including digital scans, photos, and X-rays to evaluate your orthodontic needs',
        },
        {
            title: 'Treatment Planning',
            description:
                'Development of a personalized treatment plan with options for traditional braces or clear aligners based on your needs',
        },
        {
            title: 'Braces/Aligners Placement',
            description:
                'For braces: custom fitting and bonding of brackets; For aligners: digital scanning for custom fabrication of your first sets of aligners',
        },
        {
            title: 'Regular Adjustments',
            description: 'Periodic appointments (typically every 4-8 weeks) to monitor progress and make necessary adjustments',
        },
        {
            title: 'Refinement Phase',
            description: 'Fine-tuning of tooth positions to achieve ideal alignment and bite relationship',
        },
        {
            title: 'Retention',
            description: 'Fitting of retainers and development of a retention plan to maintain your new smile',
        },
    ];

    const seoData = {
        title: 'Invisible Braces & Aligners in Sector 23, Palam Vihar, Gurgaon',
        description:
            'Looking for expert invisible braces and aligners in Sec-23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers high-quality Invisalign aligners. Call now!',
        keywords:
            'Braces & Aligners in Sector 23 Gurgaon,Invisible Braces in Gurgaon, Dental Brace Fixing Services in Gurgaon,Invisalign Aligners in Sector 23 Gurgaon,Metal Braces Fixing Near Me',
        canonical: 'https://wisdomdentalclinics.in/braces-aligners',
        ogTitle: 'Invisible Braces & Aligners in Sector 23, Palam Vihar, Gurgaon',
        ogDescription:
            'Looking for expert invisible braces and aligners in Sec-23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers high-quality Invisalign aligners. Call now!',
        twitterTitle: 'Invisible Braces & Aligners in Sector 23, Palam Vihar, Gurgaon',
        twitterDescription:
            'Looking for expert invisible braces and aligners in Sec-23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers high-quality Invisalign aligners. Call now!',
        h1Text: 'Braces & Aligners in Sector 23 Gurgaon',
    };

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
            seoData={seoData}
        />
    );
};

export default BracesAndAligners;
